import { LoanTransactionStatusId } from '@/loan/enums/loan-transaction-status-id';

export const LOAN_TRANSACTION_STATUS_MAP: ReadonlyMap<
	LoanTransactionStatusId,
	string
> = new Map<LoanTransactionStatusId, string>([
	[LoanTransactionStatusId.PENDING, 'Pending'],
	[LoanTransactionStatusId.POSTED, 'Posted'],
	[LoanTransactionStatusId.CANCELLED, 'Canceled'],
	[LoanTransactionStatusId.FAILED, 'Failed'],
	[LoanTransactionStatusId.REPLAYING, 'Replaying'],
	[LoanTransactionStatusId.REVERSAL_SUBMITTED_TO_GL, 'Reversal Submitted to GL'],
	[LoanTransactionStatusId.REVERSED, 'Reversed'],
	[LoanTransactionStatusId.SUBMITTED_TO_GL, 'Submitted to GL'],
	[LoanTransactionStatusId.TAKE_BACK_DECLINED, 'Take-Back Declined'],
]);
